<template>
    <div class="content-body">
        <el-scrollbar class="resources-scroll">
            <div class="header">
                <div class="practice-class">
                    <div class="question-class">
                        <div class="text">试题分类</div>
                        <el-cascader
                                v-model="questionsClassValue"
                                class="w350-cascader"
                                :options="questionsClassList"
                                :props="keyObjClass"
                                clearable
                                @change="handleChangeQuestionsClass">
                        </el-cascader>
                    </div>
                </div>
                <div class="search-add">
                    <el-input v-model="searchPracticeValue"
                              placeholder="请输入内容"
                              slot="prepend"
                              class="select-list-right w300-input"
                              @keyup.enter.native="practiceSearch">
                    </el-input>
                </div>
            </div>
            <div class="table-wrapper">
                <!--自己写的表格-->
                <div class="d-table">
                    <div class="d-thead">
                        <div class="d-tr">
                            <div class="d-th">
                                <div class="cell">试题名称</div>
                            </div>
                            <div class="d-th-200">
                                <div class="cell">试题分类</div>
                            </div>
                            <div class="d-th-200">
                                <div class="cell">分值</div>
                            </div>
                        </div>
                    </div>
                    <div class="d-tbody">
                        <el-scrollbar style="height: 100%">
                            <draggable :list="practiceQuestionsList"
                                       :group="{name: 'resources', pull: 'clone', put: false }"
                                       :sort="false" :move="onMove" @end="onEnd">
                                <div class="d-tr" v-for="(item, index) in practiceQuestionsList" :key="index">
                                    <div class="d-td">
                                        <div class="cell" v-if="mode === '0'">
                                            <el-checkbox v-model="checkedList" :label="item.id"
                                                         :disabled="!curIndex">{{item.name}}
                                            </el-checkbox>
                                        </div>
                                        <div class="cell" v-else>{{item.name}}</div>
                                    </div>
                                    <div class="d-td-200 resourceTit">
                                        <div class="cell">{{item.category}}</div>
                                    </div>
                                    <div class="d-td-200">
                                        <div class="cell">{{item.score}}</div>
                                    </div>
                                </div>
                            </draggable>
                        </el-scrollbar>
                    </div>
                </div>
                <div class="exampaper-import" v-if="mode === '0' && curIndex">
                    <el-button type="primary" size="small" @click="selectProjects">一键添加</el-button>
                </div>
            </div>
            <el-pagination class="pager-center" style="margin: 20px 0;text-align: center"
                           :current-page="practicePages.currentPageNum"
                           :page-size="practicePages.eachPageNum"
                           :total="practicePages.total"
                           layout="prev, pager, next, jumper"
                           @current-change="practiceCurrentChange">
            </el-pagination>
        </el-scrollbar>
    </div>
</template>

<script>
    import {cate, operationProblemExamModuleList, operationProblemOpList} from '@/utils/apis'
    import _ from "underscore";
    import draggable from "vuedraggable";

    export default {
        name: "Index",
        props: ['mode', 'curIndex', 'child'],
        components: {
            draggable
        },
        data() {
            return {
                //实操题列表
                practiceQuestionsList: [],
                //试题分类列表
                questionsClassList: [],
                keyObjClass: {
                    label: 'name',
                    value: 'id',
                    children: 'children'
                },
                questionsClassValue: [],
                //模块
                moduleList: [],
                keyObjModule: {
                    label: 'name',
                    value: 'id',
                    children: 'children'
                },
                moduleValue: [],
                //搜索
                searchPracticeValue: '',
                //分页
                practicePages: {
                    currentPageNum: 1,
                    eachPageNum: 10,
                    total: 0,
                },
                checkedList: []
            }
        },
        mounted() {
            this.getQuestionsClassList();
            this.getModuleList();
            this.getPracticeList();
        },
        methods: {
            //获取试题分类列表
            getQuestionsClassList() {
                let param = {
                    type: '3'
                }
                cate(param).then((res) => {
                    this.questionsClassList = res.data;
                }).catch((err) => {
                    console.log(err);
                });
            },
            //获取模块列表
            getModuleList() {
                let param = {
                    type: '3'
                }
                operationProblemExamModuleList(param).then((res) => {
                    this.moduleList = res.data;
                }).catch((err) => {
                    console.log(err);
                });
            },
            //获取实操题列表
            getPracticeList() {
                let param = {
                    page: this.practicePages.currentPageNum,
                    limit: this.practicePages.eachPageNum,
                }
                if (this.moduleValue.length > 0) {
                    param.exam_module_id = this.moduleValue[this.moduleValue.length - 1];
                }
                if (this.questionsClassValue.length > 0) {
                    param.category_id = this.questionsClassValue[this.questionsClassValue.length - 1];
                }
                if (this.searchPracticeValue) {
                    param.name = this.searchPracticeValue;
                }
                operationProblemOpList(param).then((res) => {
                    this.practiceQuestionsList = res.data.list;
                    this.practiceQuestionsList = _.map(res.data.list, (item) => {
                        item.material_type = 3
                        item.resource_id = item.id
                        item.name = item.op_name
                        item.type = 3
                        item.child = [];
                        return item;
                    });
                    this.practicePages.total = res.data.total;
                }).catch((err) => {
                    console.log(err);
                })
            },
            //选择试题分类
            handleChangeQuestionsClass() {
                this.getPracticeList();
            },
            //搜索
            practiceSearch() {
                this.getPracticeList();
            },
            //分页
            practiceCurrentChange(val) {
                this.practicePages.currentPageNum = val;
                this.getPracticeList();
            },
            initChecks() {
                this.checkedList = [];
            },
            selectProjects(val) {
                let arrTmp = _.filter(this.practiceQuestionsList, (item) => {
                    return this.checkedList.indexOf(item.id) !== -1;
                });
                arrTmp = _.map(arrTmp, (item) => {
                    let obj = {};
                    obj.name = item.op_name;
                    obj.id = item.id;
                    obj.child = [];
                    obj.type = 3;
                    return obj
                })
                let arr = [];
                let len = arrTmp.length;
                arrTmp.forEach((item, index) => {
                    arr.push(this.format(item));
                })
                for (let i = len; i >= 0; i--) {
                    if (arr[i] == false) {
                        arrTmp.splice(i, 1)
                    }
                }
                this.$emit('reprojects', arrTmp);
                this.initChecks();
            },
            onMove(evt) {
                let obj = evt.draggedContext.element;
                let result = this.format(obj);
                return result
            },
            format(obj) {
                let result = true;
                this.child.forEach((ele) => {
                    if (ele.child.length) {
                        ele.child.forEach((sec) => {
                            if (sec.child.length) {
                                sec.child.forEach((resource) => {
                                    if (resource != null) {
                                        if (resource.type == obj.type && resource.id == obj.id) {
                                            result = false
                                        }
                                    }
                                })
                            }
                        })
                    }
                });
                return result
            },
            onEnd(evt) {

            }
        }
    }
</script>

<style scoped lang="scss">
    .content-body {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        box-sizing: border-box;

        .resources-scroll {
            height: 100%;

            ::v-deep .el-scrollbar__view {
                padding: 0 20px;
            }
        }

        .header {
            display: flex;
            justify-content: space-between;

            .practice-class {
                display: flex;
                align-items: center;

                .question-class, .module-class {
                    display: flex;
                    align-items: center;
                    margin-right: 30px;

                    .text {
                        font-size: 16px;
                        color: #333333;;
                        margin-right: 20px;
                    }
                }

                .w350-cascader {
                    width: 250px;

                    ::v-deep.el-input__inner {
                        height: 40px;
                    }
                }
            }

            .search-add {
                display: flex;
                align-items: center;

                .select-list-right {
                    margin-right: 30px;
                }

                .w300-input {
                    width: 250px;
                }

                .w94-green-btn {
                    i {
                        font-size: 12px;
                        margin-right: 5px;
                    }
                }
            }
        }

        .content-table {
            width: 100%;
            margin-top: 20px;
            flex: 1;
            border: 1px solid #EEEEEE;
        }

        .table-wrapper {
            position: relative;
            margin-top: 20px;

            .table-content {
                .img-thumb {
                    width: 60px;
                    height: 60px;
                    overflow: hidden;

                    img {
                        display: block;
                        max-width: 100%;
                        max-height: 100%;
                    }
                }
            }

            .d-table {
                width: 100%;
                border: 1px solid #EBEEF5;
                position: relative;
                overflow: hidden;
                box-sizing: border-box;
                flex: 1;
                max-width: 100%;
                font-size: 14px;
                color: #606266;
                background-color: #FFF;

                .d-tbody {
                    height: 497px;

                    ::v-deep .el-scrollbar__view {
                        padding: 0;
                    }
                }

                .d-tr {
                    height: 53px;
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    cursor: move;

                    .d-th, .d-th-80, .d-th-100, .d-th-200 {
                        background-color: rgb(245, 247, 250);
                    }

                    .d-th-80, .d-th-100, .d-th-200, .d-td-80, .d-td-100, .d-td-200, .d-th, .d-td {
                        height: 100%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        border-bottom: 1px solid #EBEEF5;
                    }

                    .d-th, .d-td {
                        flex: 1;
                        justify-content: flex-start;
                        padding: 0 10px;
                        align-items: center;
                    }

                    .d-th-80, .d-td-80 {
                        width: 80px;
                    }

                    .d-th-100, .d-td-100 {
                        width: 100px;
                    }

                    .d-th-200, .d-td-200 {
                        width: 200px;
                    }

                    .d-td-right {
                        border-right: none;
                    }
                }
            }

            .one-import {
                position: absolute;
                bottom: 5px;
                left: 10px;
            }
        }

        .table-wrapper table {
            width: 100%;
            max-height: 500px;
            border: 1px solid #EBEEF5;
            border-right: none;
            border-bottom: none;
            position: relative;
            overflow: hidden;
            box-sizing: border-box;
            flex: 1;
            max-width: 100%;
            font-size: 14px;
            color: #606266;
            background-color: #FFF;
            border-spacing: 0;

            thead {
                color: #909399;
                font-weight: 500;

                tr {
                    background-color: #FFF;
                    height: 44px;

                    th {
                        border-bottom: 1px solid #EBEEF5;
                        font-weight: normal;
                        color: rgb(51, 51, 51);
                        background: rgb(245, 247, 250);
                        border-right: 1px solid #EBEEF5;
                    }
                }
            }

            tbody {
                tr {
                    height: 53px;

                    td {
                        border-bottom: 1px solid #EBEEF5;
                        border-right: 1px solid #EBEEF5;
                        text-align: center;
                    }
                }
            }
        }

        .pager-center {
            padding: 20px 0;
        }
    }
</style>